const Venue = () => {
    return (
        <>
        <div className="Venue-container">
            <div className="Ceremony-details">
                <div className="Title">The Ceremony</div>
                <p>The ceremony will be held at St. John Neumann Catholic Church on Friday, May 22, 2026, and begin promptly at 5 PM. Please arrive at least 15 minutes before the ceremony start time so you may be seated.</p>
                <p>12125 SW 107th Ave.
                    <br/>
                    Miami, FL 33176
                </p>
            </div>
            <hr width="20%" size="1" />
            <div className="Reception-details">
                <div className="Title">The Reception</div>
                <p>Immediately following the ceremony, a cocktail reception, followed by dinner and dancing will be held at the Coral Gables Country Club beginning at 6:30 PM. Expect an elegant and lively party where we get to celebrate our union with those we love most.</p>
                <p>997 N Greenway Dr.
                    <br/>
                    Coral Gables, FL 33134
                </p>
            </div>
            <hr width="20%" size="1" />
            <div className="Pakistani-reception-details">
                <div className="Title">The Pakistani Reception</div>
                <p>A Pakistani reception will take place the following day, Saturday, May 23, 2026 at The Club at Weston Hills. Hors D'ouevres begin at 7 PM, with the reception to follow in the adjacent ballroom.</p>
                <p>2600 Country Club Way
                    <br/>
                    Weston, FL 33332
                </p>
            </div>
        </div>
        </>
    )
};

export default Venue;